import styled from 'styled-components';

const FormFootnote = styled.div<{ hasError?: boolean }>`
  height: 0px;
  display: flex;
  justify-content: end;
  ${({ theme }) => theme.typography.small}
  color: ${({ theme, hasError }) => (hasError ? theme.color.error : theme.color.muted)};
`;

export default FormFootnote;
